import React, { useCallback } from 'react';
import EnhancedRoute, {
  EnhancedRouteProps,
} from 'router/routes/Enhanced/Enhanced.route';
import { Route, Routes as ReactRoutes } from 'react-router-dom';

export type ComplextRoute = EnhancedRouteProps & { routes: ComplextRoute[] };

type RoutesProps = {
  routes: ComplextRoute[];
};

const Routes: React.FC<RoutesProps> = ({ routes }) => {
  const calculateRoutes = useCallback(
    (routes: ComplextRoute[]) =>
      routes.map(
        (
          { path, index = false, routes, children, caseSensitive, ...rest },
          ind,
        ) => (
          <Route
            key={ind}
            index={index}
            caseSensitive={caseSensitive}
            path={path}
            element={<EnhancedRoute {...rest} />}
          >
            {routes ? calculateRoutes(routes) : children}
          </Route>
        ),
      ),
    [],
  );

  return <ReactRoutes>{calculateRoutes(routes)}</ReactRoutes>;
};

export default Routes;
